<div class="auto-servicing">
    <div class="coming-soon-area ripple-playing jquery-ripples">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 col-md-12">
                            <div class="coming-soon-content">
                                <div class="logo">
                                    <a routerLink="/auto-servicing"><img src="assets/img/white-logo.png" alt="logo"></a>
                                </div>
                                <h1>We're launching our <span>new website</span></h1>
                                <p>Working hard for something we don't care about is called stress. Working hard for something we love is called passion.</p>
                                <form class="newsletter-form">
                                    <input type="email" class="input-newsletter" placeholder="Enter email address" name="EMAIL">
                                    <button type="submit">Subscribe <i class="far fa-paper-plane"></i></button>
                                </form>
                                <div class="social">
                                    <ul>
                                        <li><a href="#" target="_blank" class="twitter"><i class="fab fa-twitter"></i></a></li>
                                        <li><a href="#" target="_blank" class="youtube"><i class="fab fa-youtube"></i></a></li>
                                        <li><a href="#" target="_blank" class="facebook"><i class="fab fa-facebook-f"></i></a></li>
                                        <li><a href="#" target="_blank" class="linkedin"><i class="fab fa-linkedin-in"></i></a></li>
                                        <li><a href="#" target="_blank" class="instagram"><i class="fab fa-instagram"></i></a></li>
                                    </ul>
                                </div>
                                <div class="copyright-text">
                                    <p><i class="far fa-copyright"></i> Ngcont, All right reserved</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>